export default "__VITE_ASSET__2ULr2lqE__"